import React, {useEffect, useState} from "react";
import {tipoIndicador} from "../SeguimentoConstantes";
import ExGrid from "../../../../shared/Grid/ExGrid";
import ExColumn from "../../../../shared/Grid/ExColumn";
import {fechaUtc} from "../../../../shared/Grid/GridCellRenderers";
import {useControlMap} from "../ControlMapProvider";
import useApiViajeSeguimientoMonitoreo from "../../../../api/operaciones/useApiSeguimientoMonitoreo";
import AtenderIncidenciaModal from "./AtenderIncidenciaModal";
import AddButton from "../../../../shared/Grid/Buttons/AddButton";

const InformacionSeguimiento = React.memo(({viaje, onChangeBitacora}) => {
    const [seguimiento, setSeguimiento] = useState()
    const [incidenciaActual, setIncidenciaActual] = useState(null);
    const {setNotificacionSeleccionada} = useControlMap()
    const api = useApiViajeSeguimientoMonitoreo()
    const handleSeleccion = async (item) => {
        setNotificacionSeleccionada(
            {
                lat: item.latitud,
                lng: item.longitud
            }
        )
    }
    const enviarWhCoordinadores = async()=> {
        await api.envioWppCoordinador(viaje.id);
    }
 useEffect(() => {
    const data = viaje?.bitacora?.filter(e => e.indicador === tipoIndicador.seguimiento || e.atendido === true) ?? [];
    setSeguimiento(data);
}, [viaje]);
    const agregar = () => {
        setIncidenciaActual({
        id: 0,                 
        comentarios: "",
        razonId: null,
        indicador: tipoIndicador.seguimiento, 
        atendido: false,
        });
    };
    return (
        <div className={'seg-info-viaje'}>
            <div>
                <span style={{fontSize: '1.2em', fontWeight: 'bold'}}>
                    HISTORIAL DE SEGUIMIENTO
                </span>
            </div>
            <div>
                
                <ExGrid data={seguimiento}>
                  
                    <ExColumn field={'fechaAtiende'} title={'Fecha'} cellRenderer={fechaUtc}></ExColumn>
                    <ExColumn field={'usuarioAtiende'} title={'Usuario Atiende'}></ExColumn>
                    <ExColumn field={'comentarios'} title={'Comentarios'}></ExColumn>
                    <ExColumn field={'razon'} title={'Razon'}></ExColumn>
                    <ExColumn field={'posicionGps'} title={'Posición GPS'}
                              cellRenderer={({value}) => (<span className={'link'} onClick={()=>handleSeleccion(value)}> {value?.latitud}, {value?.longitud}</span>)}>
                    </ExColumn>
                    <ExColumn field={'ubicacion'} title={'Ubicacion'}></ExColumn>

                   <ExColumn field={"command"}
                                  headerRenderer={({onAdd})=> <AddButton onAdd={agregar}/>}                                 
                                  width={'50px'} />                        
                </ExGrid>
            </div>
         <div className="form-value" style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '12px' }}>
            <span className={'form-value'}>
                Aviso Urgente a Coordinador
            </span>
            <img
                src="../../../../img/whatsapp.png"
                width="33px"
                alt="Enviar WhatsApp" 
                style={{ marginLeft: '2px' }}
                onClick={enviarWhCoordinadores} 
            />
        </div>
        {/* Modal */}
              <AtenderIncidenciaModal
                viajeId={viaje.id}
                incidenciaActual={incidenciaActual}        
                setIncidenciaActual={setIncidenciaActual}
                onChangeBitacora={onChangeBitacora}
                envio={true}
            />
        </div>
    )
})
export default InformacionSeguimiento;